import { PayInvoicePageContext } from "@auer-steel/Pages/PayInvoicePage";
import { AuerState } from "@auer-steel/Store/AuerState";
import updateInvoicePayments from "@auer-steel/Store/Pages/PayInvoice/Handlers/UpdateInvoicePayments";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: AuerState) => ({
    invoicePaymentCollection: state.payInvoice.invoicePaymentCollection,
});

const mapDispatchToProps = {
    updateInvoicePayments,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const PaymentNotes: React.FunctionComponent<Props> = (props: Props) => {
    if (props.invoicePaymentCollection.invoicePayments.length < 1) {
        return null;
    }
    const handleNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        props.updateInvoicePayments({
            ...props.invoicePaymentCollection,
            paymentNotes: event.target.value,
        });
    };

    return <TextArea onChange={handleNotesChange} label={translate("Payment Notes")} />;
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PaymentNotes),
    definition: {
        group: "Pay Invoice" as any,
        allowedContexts: [PayInvoicePageContext],
    },
};

export default widgetModule;
